import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"padding":"0 8%"},
  class: "w100 usage ofx"
}
const _hoisted_2 = { class: "usageContent" }
const _hoisted_3 = { class: "step1" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "step2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "step3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/tutorial/step1.png`)
          }, null, 8, _hoisted_4)
        ]),
        (_ctx.isSP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_9, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/tutorial/step2.png`)
          }, null, 8, _hoisted_10)
        ]),
        (_ctx.isSP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_15, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/tutorial/step3.png`)
          }, null, 8, _hoisted_16)
        ]),
        (_ctx.isSP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_21,
    _hoisted_22
  ]))
}